import cookies from "react-cookies"
const TOKEN_KEY = "access_token";
/**
 * token工具类
 * @type {{}}
 */
const TokenUtil = {

    getToken(){
        return cookies.load(TOKEN_KEY)
    }
};

export default TokenUtil;
